import { Terminal, MessageSquare, LayoutDashboard, ChevronRight } from 'lucide-react';
import { Outlet, NavLink } from 'react-router-dom';

const nav = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/terminal', icon: Terminal, label: 'Terminal' },
  { to: '/chat', icon: MessageSquare, label: 'AI Chat' },
];

export function Layout() {
  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <aside
        style={{
          width: 220,
          background: '#161b22',
          borderRight: '1px solid #30363d',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #30363d' }}>
          <h1 style={{ fontSize: 18, fontWeight: 700, color: '#d6a94e', letterSpacing: '0.02em' }}>
            Orion Web
          </h1>
          <span style={{ fontSize: 11, color: '#8b949e' }}>Aether Tech AI</span>
        </div>
        <nav style={{ flex: 1, padding: '12px 8px' }}>
          {nav.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '10px 12px',
                borderRadius: 6,
                color: isActive ? '#58a6ff' : '#8b949e',
                background: isActive ? '#1f2937' : 'transparent',
                fontSize: 14,
                marginBottom: 2,
                textDecoration: 'none',
              })}
            >
              <Icon size={18} />
              {label}
              <ChevronRight size={14} style={{ marginLeft: 'auto', opacity: 0.4 }} />
            </NavLink>
          ))}
        </nav>
        <div
          style={{
            padding: '12px 16px',
            borderTop: '1px solid #30363d',
            fontSize: 11,
            color: '#484f58',
          }}
        >
          Orion v1.0.0
        </div>
      </aside>
      <main style={{ flex: 1, overflow: 'auto', background: '#0d1117' }}>
        <Outlet />
      </main>
    </div>
  );
}
